import React from 'react'
import LeftNavLayout from '../../../components/left-nav-layout'
import LeftNav from '../../../components/left-nav'
import PageNotFound from '../../page-not-found'
import LoadingSpinner from '../../../components/loading-spinner'
import useFetchLibraryFolders from '../../../hooks/useFetchLibrary'
import PropTypes from 'prop-types'

/**
 * A layout wrapper that conditionally renders the LeftNav
 * based on whether content exists.
 */
const ContentWithToggleNav = ({contentPath, Component}) => {
    const {data, loading, error} = useFetchLibraryFolders(contentPath)

    if (loading) return <LoadingSpinner />

    const hasContent = !!data?.c_body

    if (!hasContent) {
        return <PageNotFound />
    }

    return (
        <LeftNavLayout sidebar={<LeftNav />}>
            <Component data={data} loading={loading} error={error} />
        </LeftNavLayout>
    )
}

ContentWithToggleNav.propTypes = {
    contentPath: PropTypes.string.isRequired,
    Component: PropTypes.elementType.isRequired
}

export default ContentWithToggleNav
